import { CoreStakeholdersName } from './name';
import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postStakeholder } from '@api';

export const coreStakeholdersPostAsyncSlice = createPostAsyncSlice({
	name: CoreStakeholdersName,
	receive: true,
	request: true,
	requestHandler: postStakeholder
});
